// extracted by mini-css-extract-plugin
export default {"section":"SettingsSidebar-module__section--Hx03w","homeButton":"SettingsSidebar-module__homeButton--nOlXH","animatedBackground":"SettingsSidebar-module__animatedBackground--iDSwR"};